import ImageIcon from '@mui/icons-material/Image';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const getLocalIDToken = () => {
  return localStorage.getItem('louidtoken');
};

export const setLocalIDToken = (IdToken: any) => {
  localStorage.setItem('louidtoken', IdToken);
};
export const getLocalAccessToken = () => {
  return localStorage.getItem('louaccesstoken');
};

export const setLocalAccessToken = (IdToken: any) => {
  localStorage.setItem('louaccesstoken', IdToken);
};
export const getLocalRefreshToken = () => {
  return localStorage.getItem('louRefreshToken');
};

export const setLocalRefreshToken = (IdToken: any) => {
  localStorage.setItem('louRefreshToken', IdToken);
};
export const setLoginName = (username: any) => {
  localStorage.setItem('username', username);
};
export const getLoginName = () => {
  return localStorage.getItem('username');
};
export const getCurrentDate = () => {
  return (
    new Date().getFullYear() +
    '-' +
    (new Date().getMonth() + 1) +
    '-' +
    new Date().getDate()
  );
};
export const currentDatePlusDate = (
  year: number,
  month: number,
  day: number
) => {
  const dateStr: string =
    new Date().getFullYear() +
    year +
    '-' +
    (new Date().getMonth() + 1 + month) +
    '-' +
    (new Date().getDate() + day);
  // console.log(new Date().getMonth() + 1 + month, '-->>>>>>>', dateStr);
  return dateStr;
};

export const getStoredMenuItems = () => {
  const menuItems: any = localStorage.getItem('loumacMenus');
  return menuItems ? (menuItems !== '' ? JSON.parse(menuItems) : '') : '';
};

export const setStoredMenuItems = (menuItems: any[]) => {
  localStorage.setItem('loumacMenus', JSON.stringify(menuItems));
};
export const getFormatDate = (value: any) => {
  return new Date(value).toLocaleDateString('default', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};
export const getFormatDateTime = (value: any) => {
  return new Date(value).toLocaleDateString('default', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
};
export const getPickerFormatDate = (value: any) => {
  return new Date(value);
};

export const getFileType = (filename: any, id: any, handleOpen: any) => {
  if (!filename.includes('.')) return 'Unknown';

  const extension = filename.split('.').pop().toLowerCase();

  const imageCatgories = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
  const pdfDocCategories = ['pdf'];
  if (imageCatgories.indexOf(extension) !== -1) {
    return (
      <ImageIcon
        onClick={() => {
          handleOpen(id);
        }}
        sx={{ fontSize: '20px', cursor: 'pointer' }}
      />
    );
  } else if (pdfDocCategories.indexOf(extension) !== -1) {
    return (
      <PictureAsPdfIcon
        onClick={() => {
          handleOpen(id);
        }}
        sx={{ fontSize: '20px', cursor: 'pointer' }}
      />
    );
  } else {
    return (
      <InsertDriveFileIcon
        onClick={() => {
          handleOpen(id);
        }}
        sx={{ fontSize: '20px', cursor: 'pointer' }}
      />
    );
  }
};
export const downloadFile = (response: any, fileName: any) => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  const pdfName = fileName;
  link.setAttribute('download', pdfName);
  document.body.appendChild(link);
  link.click();
};
export const getShiftStatusText = (status: number) => {
  if (status === 0) {
    return 'Draft';
  } else if (status === 1) {
    return 'Sent to Crew';
  } else if (status === 2) {
    return 'Foreman Completed';
  } else if (status === 3) {
    return 'Under Review';
  } else if (status === 4) {
    return 'Completed';
  } else {
    return 'Draft';
  }
};

export const base64ToFile = (base64Data: any) => {
  const base64String = base64Data.replace(/^data:image\/\w+;base64,/, '');
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: 'image/png' });
};
export function setStoredValue<T>(key: string, valueToStore: T) {
  try {
    // Save to local storage
    window.localStorage.setItem(key, JSON.stringify(valueToStore));
  } catch (error) {
    console.log(error);
  }
}

export function getStoredValue<T>(key: string, initialValue: T) {
  try {
    // Get from local storage by key
    const item = window.localStorage.getItem(key);
    // Parse stored json or if none return initialValue
    return item ? JSON.parse(item) : initialValue;
  } catch (error) {
    // If error also return initialValue
    console.log(error);
    return initialValue;
  }
}

export function deepEqual(a: any, b: any): boolean {
  if (a === b) return true;

  if (typeof a !== 'object' || typeof b !== 'object' || a == null || b == null)
    return false;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEqual(a[key], b[key])) return false;
  }

  return true;
}
export const handleErrorMessage = (error: any) => {
  try {
    let message: any = error.message;
    if (error.response) {
      if (error.response.data) {
        if (error.response.data.message) {
          message = error.response.data.message;
        }
      }
    }
    return message;
  } catch (e: any) {
    return 'Problem with server, please try again later';
  }
};

export function roundToTwo(num: any): any {
  const parsed = parseFloat(num);
  if (isNaN(parsed)) return parsed;
  return Number(Math.round(Number(parsed + 'e+2')) + 'e-2');
}

export function roundToFour(num: any): any {
  const parsed = parseFloat(num);
  if (isNaN(parsed)) return parsed;
  return Number(Math.round(Number(parsed + 'e+4')) + 'e-4');
}

export const formatPrice = (value: any): string => {
  const num = parseFloat(value);
  if (isNaN(num)) return '';
  return num.toFixed(5).replace(/(\.\d{2})(\d*?)0+$/, '$1$2');
};

// Tidy a partially-typed decimal when a field loses focus, without forcing
// trailing zeros. Adds a leading zero (".75" -> "0.75"), drops a dangling
// decimal point ("5." -> "5") and a lone "-"/"." becomes empty. Preserves
// what the user typed otherwise (e.g. "5.50" stays "5.50").
export const normalizeDecimalBlur = (raw: any): string => {
  let s = String(raw ?? '').trim();
  if (s === '' || s === '-' || s === '.' || s === '-.') return '';
  const negative = s.startsWith('-');
  s = s.replace(/^-/, '');
  if (s.startsWith('.')) s = '0' + s;
  if (s.endsWith('.')) s = s.slice(0, -1);
  if (s === '' || s === '.') return '';
  return (negative ? '-' : '') + s;
};

export const formatPriceSmart = (value: any): string => {
  const num = parseFloat(value);
  if (isNaN(num)) return '';
  if (num !== 0 && Math.abs(num) < 0.01) {
    return num.toFixed(5).replace(/(\.\d{2})(\d*?)0+$/, '$1$2');
  }
  return roundToTwo(num).toFixed(2);
};
